import React from 'react'

import { VsShieldIcon } from '@octane/spark'

import { IconWrapper } from './IconWrapper.styled'

const ICON_SIZE = 16

type VerifiedIconProps = {
    readonly size?: number
}

const VerifiedIcon = ({ size }: VerifiedIconProps) => {
    return (
        <IconWrapper title="Verified Shield">
            <VsShieldIcon
                width={size ?? ICON_SIZE}
                height={size ?? ICON_SIZE}
            />
        </IconWrapper>
    )
}

export default VerifiedIcon
